import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { EVENTS } from './constants';
import { serializer as transactionSerializer } from '../transaction/serializer';
import { serializer as customerSerializer } from '../customers/serializer';

bus.on(EVENTS.HOME.STATS.REFRESH, () => {
  const userStore = getStore('user');
  if (!userStore?.state?.current?.id) return;

  const trxReqId = `homeTrxCount-${Date.now()}`;
  const custReqId = `homeCustCount-${Date.now()}`;

  const trxUrl = `${constants.ENDPOINTS.TRANSACTIONS.GET_LIST}`
    .replace('{userId}', '')
    .replace('{offset}', '0')
    .replace('{limit}', '1');

  const custUrl = `${constants.ENDPOINTS.CUSTOMERS.GET_LIST}`
    .replace('{userId}', userStore.state.current.id)
    .replace('{offset}', '0')
    .replace('{limit}', '1');

  bus.emit(EVENTS.HOME.STATS.REFRESHING);

  // Dispatch both requests in parallel
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: trxReqId,
    url: trxUrl,
    method: 'GET'
  });

  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: custReqId,
    url: custUrl,
    method: 'GET'
  });

  let totalTransactions = 0;
  let totalCustomers = 0;
  let completed = 0;
  let hasError = false;

  const checkCompletion = () => {
    if (completed === 2) {
      bus.off(constants.EVENTS.NETWORK.RESPONSE, handler);
      if (hasError) {
        bus.emit(EVENTS.HOME.STATS.REFRESH_ERROR, 'Impossible de récupérer les statistiques');
      } else {
        bus.emit(EVENTS.HOME.STATS.REFRESHED, {
          clientBalance: 0,
          totalTransactions,
          totalCustomers,
          netProfit: 0,
          successfulTransactions: 0,
          failedTransactions: 0
        });
      }
    }
  };

  const handler = (res) => {
    if (res.id === trxReqId) {
      completed++;
      if (res.error) {
        hasError = true;
      } else {
        const parsed = transactionSerializer.deserialize(res);
        if (parsed.success) {
          totalTransactions = parsed.data.total;
        } else {
          hasError = true;
        }
      }
      checkCompletion();
    } else if (res.id === custReqId) {
      completed++;
      if (res.error) {
        hasError = true;
      } else {
        const parsed = customerSerializer.deserialize(res);
        if (parsed.success) {
          totalCustomers = parsed.data.total;
        } else {
          hasError = true;
        }
      }
      checkCompletion();
    }
  };

  bus.on(constants.EVENTS.NETWORK.RESPONSE, handler);
});
